export const PROFILE = {
  name: "Dr. Rahul Kanungo",
  degrees: "MBBS · MD (Pathology, Gold Medal) · MBA (Healthcare & Hospital Management)",
  roles: ["Consultant Pathologist", "Applied-AI in Healthcare", "Health-tech Builder"],
  tagline:
    "Consultant pathologist with a special interest in hematopathology practice — MBA-credentialed for healthcare administration, builder of four AI-native health-tech products, and open to consulting, leadership and collaborations worldwide.",
  location: "Bhubaneswar, Odisha, India",
  email: "hi@rahulkanungo.com",
  phone: "+91 82175 73134",
  whatsapp: "https://wa.me/918217573134",
  instagram: "https://www.instagram.com/the_hematopath",
  instagramHandle: "@the_hematopath",
  availability: "Open to consulting, administrative & leadership roles — onsite Bhubaneswar · remote worldwide",
};

export const MARQUEE = [
  "MD Pathology — Gold Medalist",
  "6 Indexed Publications",
  "e-parchi",
  "Nirogyam AI",
  "Occusafe",
  "LabTrack",
  "MBA — Healthcare Management",
  "Meta-Verified · 17K+ Organic Reach",
  "ISO 15189 · NABL",
  "Consulting Across India & Worldwide",
];

// Order matters: professional metrics first, personal (books) LAST.
export const STATS = [
  { value: 4, suffix: "", label: "Production health-tech products", sub: "e-parchi · Nirogyam AI · Occusafe · LabTrack" },
  { value: 6, suffix: "", label: "Indexed publications", sub: "PubMed · Scopus · EMBASE" },
  { value: 17, suffix: "K+", label: "Organic audience reach", sub: "Instagram + Facebook · open to brand collaborations" },
  { value: 3, suffix: "", label: "Books authored", sub: "personal pursuit · published author" },
];

export const CAPABILITIES = {
  clinical: [
    "Bone marrow aspiration & biopsy reporting",
    "Hb & serum protein electrophoresis",
    "IHC & urinalysis",
    "Transfusion medicine",
    "Leukemia & lymphoma workups",
    "EQAS & quality control",
  ],
  tech: [
    "Digital pathology",
    "AI / LLM product design",
    "NABL · ISO 15189:2022 audits",
    "LIS / LIMS operations",
    "Healthcare administration & strategy",
    "Teaching & patient counselling",
  ],
};

export const VENTURES = [
  {
    id: "eparchi",
    index: "01",
    name: "e-parchi",
    tagline: "AI-powered prescription workspace — write, sign and archive prescriptions at the speed of thought.",
    detail: "An AI medicine & dosage engine with exact compositions and Indian brand matches, patient auto-UID records, smart recall and time-stamped digitally signed PDFs. Built for Nirogyam Diagnostics and Healthcare.",
    tech: ["AI Medicine Engine", "Digital Signatures", "Patient Records"],
    role: "Creator & Product Architect",
    url: null,
    live: true,
    accent: "cyan",
  },
  {
    id: "nirogyam-ai",
    index: "02",
    name: "Nirogyam AI",
    tagline: "Your lab report, finally in plain words — AI report interpretation in 30+ languages.",
    detail: "Uploads any diagnostic report and returns clear, chart-based summaries with next steps — doctor-validated, private and multilingual. Built for Nirogyam Diagnostics and Healthcare.",
    tech: ["Report Interpretation", "30+ Languages", "Doctor Validation"],
    role: "Chief Innovator & Medical AI Lead",
    url: null,
    live: true,
    accent: "violet",
  },
  {
    id: "occusafe",
    index: "03",
    name: "Occusafe",
    tagline: "Occupational hazard & incident reporting workflow management for healthcare centres.",
    detail: "Closing the safety loop for clinical staff — hazard capture, incident workflows and compliance-ready analytics.",
    tech: ["Incident Workflows", "Safety Analytics", "Compliance"],
    role: "Healthcare Systems Architect",
    url: null,
    live: false,
    accent: "violet",
  },
  {
    id: "labtrack",
    index: "04",
    name: "LabTrack",
    tagline: "The daily operating system for haematology laboratories — built for Pathlete India.",
    detail: "Samples, turnaround time, critical alerts, Westgard QC, SOPs, inventory and ISO 15189 personnel records — one audited, exportable workspace.",
    tech: ["Lab OS", "Westgard QC", "TAT & Alerts"],
    role: "Co-creator & Domain Expert",
    url: "https://labtrack.pathletetechnologies.com/",
    live: true,
    accent: "cyan",
  },
];

export const EXPERIENCE = [
  {
    period: "Jul 2026 — Present",
    role: "Assistant Professor, Dept. of Lab Hematology",
    org: "IMS & SUM Hospital – II, Phulnakhara, Bhubaneswar",
    points: [
      "Deputy Technical Manager (Aug 2026) — internal audits, stringent QC, EQAS and NABL accreditation scope, documentation & proficiency testing.",
      "Standardised the Hammersmith Protocol for bone-marrow biopsy decalcification (Jul 2026) — sharper cellular architecture, reduced turnaround time.",
      "Independent reporting across the full haematology & clinical pathology menu.",
    ],
    current: true,
  },
  {
    period: "Jun 2025 — Jul 2026",
    role: "Senior Resident, Dept. of Lab Hematology",
    org: "IMS & SUM Hospital II, Phulnakhara",
    points: [
      "Ran high-volume hematology & clinical pathology benches with resident teaching.",
      "Digital pathology and AI-assisted workflows for better research prospects.",
    ],
  },
  {
    period: "Apr 2022 — Feb 2025",
    role: "Tutor & Postgraduate — MD Pathology (Gold Medal)",
    org: "BLDE DU, Shri B.M. Patil Medical College, Vijayapura",
    points: [
      "MD Pathology awarded Jan 2025 with the university Gold Medal.",
      "Platform & poster presentations at APCON, KAPCON and SARS forums.",
    ],
  },
  {
    period: "2020 — 2022",
    role: "Junior Resident (Nephrology) · Internship",
    org: "IMS & SUM Hospital, Bhubaneswar",
    points: [
      "Six months of clinical nephrology residency.",
      "Rotatory internship (Mar 2020 – Mar 2021) across major specialties.",
    ],
  },
  {
    period: "Education",
    role: "MBA — Healthcare & Hospital Management",
    org: "D.Y. Patil University, Navi Mumbai · awarded Jan 2024",
    points: [
      "Built for the boardroom: hospital operations, healthcare administration and management strategy.",
      "Alongside MD Pathology — BLDE DU (Gold Medal, Jan 2025) and MBBS — IMS & SUM Hospital, SOAU (2020).",
    ],
  },
];

export const PUBLICATIONS = [
  {
    authors: "Kanungo R, Hippargi SB",
    title: "CD64 Expression on Neutrophils (nCD64) as a Biomarker in Adult Patients With Sepsis: A Cross-Sectional Study",
    journal: "Cureus",
    year: "2024",
    index: "PubMed",
    ref: "doi 10.7759/cureus.71912 · PMID 39429998",
  },
  {
    authors: "Kanungo R, Sharma A, Pagi S, Sachar K",
    title: "Exploring Occupational Health Challenges in Pathology: A Cross-Sectional Survey of Indian Pathologists",
    journal: "Cureus",
    year: "2024",
    index: "PubMed",
    ref: "doi 10.7759/cureus.75264 · PMID 39776702",
  },
  {
    authors: "Sharma A, Arakeri S, Kanungo R, Pagi S",
    title: "Hematological Changes in Platelet Apheresis Donors: An Observational Study",
    journal: "Cureus",
    year: "2024",
    index: "PubMed",
    ref: "doi 10.7759/cureus.73907 · PMID 39697965",
  },
  {
    authors: "Patil VS, Kanungo R",
    title: "Tenosynovial Giant Cell Tumor of Digit Diagnosed on Cytology: A Case Report",
    journal: "JKIMSU",
    year: "2024",
    index: "Scopus",
    ref: "Vol 13(2)",
  },
  {
    authors: "Patil VS, Patil N, Kanungo R",
    title: "Aggressive Angiomyxoma of Pelvis: Diagnostic Challenge",
    journal: "JKIMSU",
    year: "2023",
    index: "Scopus",
    ref: "Vol 12(3)",
  },
  {
    authors: "Kanungo R, Hippargi SB",
    title: "Microbial Spectrum in Adult Sepsis and Its Correlation with Neutrophil CD64 (nCD64) Expression",
    journal: "Annals of Pathology and Laboratory Medicine",
    year: "2025",
    index: "EMBASE",
    ref: "Vol 12(2):A30-7",
  },
];

export const CREDENTIALS = [
  { name: "Neuropathology Training", org: "NIMHANS, Bengaluru", year: "2024" },
  { name: "11th Basic Hematology Course", org: "Tata Memorial Hospital, Mumbai", year: "2024" },
  { name: "Digital Pathology Certificate", org: "Medvarsity · AHERF", year: "2024" },
  { name: "ISO 15189:2022 Lab Mgmt & Internal Audit", org: "MELAP", year: "2023" },
  { name: "NABH Clinical Audit", org: "NABH", year: "2025" },
  { name: "CPCDM — Clinicians in Diabetes", org: "RSSDI", year: "2024" },
  { name: "Good Clinical Practices", org: "NIDA Clinical Trials Network", year: "2024" },
  { name: "Ethics Review of Health Research", org: "NIE-ICMR", year: "2024" },
  { name: "Biomedical Research (BCBR)", org: "NIE-ICMR · NPTEL", year: "2023" },
  { name: "ACLS & BLS Provider", org: "American Heart Association", year: "2024–2027" },
  { name: "Basics of Flow Cytometry", org: "Flow Cytometry Solutions", year: "—" },
  { name: "Nephropathology Workshop", org: "M.S. Ramaiah MC · APCON 2022", year: "2022" },
];

export const CONFERENCES = [
  { title: "Oral paper — Role of neutrophilic CD64 in the diagnosis of sepsis", venue: "APCON 2023, IAPM, AIIMS New Delhi", year: "2023" },
  { title: "Poster — Aggressive angiomyxoma of the uterus misdiagnosed as fibroid", venue: "APCON 2022, M.S. Ramaiah MC, Bengaluru", year: "2022" },
  { title: "Platform — Tenosynovial giant cell tumor of digit on cytology", venue: "SARS Committee, BLDE DU", year: "—" },
  { title: "Delegate + Flow Cytometry workshop", venue: "KAPCON 2023, KMC Mangalore", year: "2023" },
  { title: "Digital Health pre-conference CME", venue: "IA-PSM Karnataka Chapter, BLDE DU", year: "2023" },
  { title: "40th Annual National CME, Dept. of Pathology", venue: "JNMC, KLE Academy, Belagavi", year: "2022" },
];

export const SOCIAL = {
  instagram: {
    handle: "@the_hematopath",
    followers: "12K+",
    label: "organic, non-bot followers across diverse fields",
    verified: true,
    url: "https://www.instagram.com/the_hematopath",
  },
  facebook: {
    handle: "Dr. Rahul Kanungo",
    followers: "5K",
    label: "followers",
    verified: false,
    url: null,
  },
  total: "17K+",
};

// Audience positioned as a professional asset for brand / promotion partners.
export const AUDIENCE_TRAITS = [
  { title: "100% organic", text: "Grown without paid followers or bots — real accounts, real engagement." },
  { title: "Cross-field reach", text: "Clinicians, students, health-tech professionals and a broad general audience." },
  { title: "Meta-verified", text: "Verified identity on Instagram — a credible, brand-safe medical voice." },
];

export const COLLAB_FORMATS = [
  "Health-tech & product launches",
  "Brand promotion & sponsored content",
  "Health-awareness & medical-education campaigns",
  "Events, webinars & speaking",
];

export const BOOKS = [
  { title: "This book will never sell", year: "January 2020" },
  { title: "Rudrayoga — Rudra ke aur kareeb", year: "December 2019" },
  { title: "Reconciliation — Rhythms from the 21st century", year: "August 2018" },
];

export const LITERARY_AWARDS = [
  "Swami Vivekananda Excellence Award in Literature — Kolkata, 2019",
  "1st Prize, Poetry — OSMECON, Osmania Medical College, 2018",
  "1st Prize, Poetry — IADVL, IMS & SUM Hospital, 2018",
  "Co-author across five anthologies",
];

export const SCOPES = [
  "Consultant pathologist — hematopathology interest (part-time)",
  "Healthcare administration & lab leadership",
  "Lab quality · NABL & ISO 15189",
  "Health-tech product consulting",
  "Brand & audience collaborations · 17K+ reach",
  "Tele-consulting & reporting",
  "Speaking · teaching · workshops",
];

export const MEMBERSHIPS = [
  "IAPM Associate Member · A-3733",
  "KCIAPM Life Member · L-2398",
  "ISHBT Life Member · L-2561",
  "OCMR Reg. 26663/2021",
  "CAHO Life Member",
  "ASQ Member",
];